import { useLocale } from '@/providers/LocaleProvider';
import { useSnackbar } from '@/providers/SnackbarProvider';
import { LearnUponInstance } from '@/types/views/enrollment.types';
import { useAppMutation } from './useAppMutation';

interface UnenrolStudentPayload {
  learnUponEnrollmentId: string;
  /** LU portal hosting this enrolment. Backend rejects calls without it — IDs collide across portals. */
  instance: LearnUponInstance;
  /** The organisation's own LearnUpon portal, for its enrolments; the backend then ignores instance. */
  integrationId?: string;
}

export const useUnenrolStudent = (options?: { onSuccess?: () => void }) => {
  const { showSnackbar } = useSnackbar();
  const { translate } = useLocale();

  return useAppMutation<unknown, Error, UnenrolStudentPayload>(
    'post',
    '/TrainingManager/courses/unenrol',
    {
      onSuccess: () => {
        options?.onSuccess?.();
        showSnackbar(translate('manage.courseStudents.studentUnenrolledSuccessfully'), 'success');
      },
    }
  );
};
